// These will be eventually from an api
export const functions = [
  {
    label: "Technology",
  },
  { label: "Health Care" },
  { label: "Financials" },
  { label: "Consumer Discretionary" },
  { label: "Communication Services" },
  { label: "Industrials" },
  { label: "Consumer goods" },
  { label: "Energy" },
  { label: "Utilities" },
  { label: "Real Estate" },
  { label: "Materials" },
  { label: "Agriculture" },
  { label: "Services" },
  { label: "Other" },
  { label: "E-Commerce" },
  { label: "Start-up" },
  { label: "textile" },
];
export const useCases = [
  { label: "Support" },
  { label: "Marketing" },
  { label: "Sales" },
  { label: "Finance" },
  { label: "Information Technology (IT)" },
  { label: "Human Resources (HR)" },
  { label: "Communications" },
  { label: "Legal" },
  { label: "Public Relations (PR)" },
  { label: "Product, design, and UX" },
  { label: "Project Management" },
  { label: "Personal" },
  { label: "Remote work" },
  { label: "Software Development" },
];

export const TEMPLATE_BUILDING_BLOCKS_FILTER_FUNCTION_VALUE = "Building Blocks";
export const TEMPLATE_ALL_FILTER_FUNCTION_VALUE = "All";
export const BUILDING_BLOCK_THUMBNAIL_ALT_TEXT = "Building Block Thumbnail";
